




import { Component, Vue } from "vue-property-decorator";

import EntityCrud from "../layouts/components/EntityCrud.vue";
import { FilterDefinition } from "../layouts/components/EntityFilter.vue";

//import appointmentEventModel from "../models/appointment_event.model";
import appointmentReportModel from "@/models/appointment_report.model";
import companyModel from "../models/company.model";

@Component({
  components: { EntityCrud },
})
export default class Appointments extends Vue {
  model: any = appointmentReportModel;

  title = "Consultas";
  filterDefinition: FilterDefinition = [
    { fieldKey: "startDateTime", label: "Data da consulta" },
    //{ fieldKey: "appointmentStatus", defaultSelectOptions: ["CONFIRMATION_PENDING", "CONFIRMED", "COMPLETED", "FAILED"] },
    //{ fieldKey: "appointmentStatus", defaultSelectOptions: ["SLOT_AVAILABLE", "COMPLETED", "FAILED","CONFIRMED"], options: ["SLOT_AVAILABLE", "COMPLETED", "FAILED", "CONFIRMED"] },
    { fieldKey: "status", defaultSelectOptions: ["REALIZADO", "CANCELADO"] },
    { fieldKey: "voucher.company", model: companyModel },
    { fieldKey: "appointmentType", defaultSelectOptions: ["FIQUEOK", "TEAMS", "WHATSAPP"] },        
  ];
  tableColumns = ["startDateTime", "duration", "appointmentType", "patientUserName", "psychologistUserName", "status", "voucherCode", "voucherCompanyName"];
  //headers que serão exibidos na grid de resultados
  tableHeaders = ["Data/Hora", "Duração", "Canal", "Paciente", "Psicólogo", "Status", "Voucher", "Empresa"];
  exportColumns = ["patientUserRegister", "patientUserType", "startDateTime", "appointmentKind", "appointmentType", "patientUserName", "psychologistUserName", "status", "voucherCode", "voucherCompanyName", "statusStatus", "statusReason", "statusPriority", "medicalRecord"];
  //headers que serão montados na planilha
  exportHeaders = ["Matrícula", "Tipo funcionário", "Data/Hora", "Duração", "Tipo", "Paciente", "Psicólogo", "Status", "Voucher", "Empresa", "Status da Consulta", "Motivo", "Prioridade", "Prontuário do paciente"];
  
  filter = {
    'appointmentkind': {
      $in: ["SINGLE", "DOUBLE"],
    },
  };
  // filter = {};

  formColumns = ["startDateTime", "kind", "patientUser", "psychologistUser"];
  defaultEntity = {};
}
